import React from 'react';
import { Link } from 'react-router-dom'

const prodListaMod = ({producto}) => {
	return(
		<div className="col-12 col-sm-6 col-md-3 mb-3">
			<Link to={'/producto/'+producto.id}>
			<div className="card" >
				<div className="p-2">
					<img className="card-img-top" src={"https://firebasestorage.googleapis.com/v0/b/veltonaccesos-113f7.appspot.com/o/productos%2F"+producto.img+"?alt=media"} alt={producto.nombre}/>
				</div>
				<div className="card-body p-2">
					<h5 className="prod-tit-mod">{producto.nombre}</h5>
					<p className="card-title">{producto.descripcion_corta}</p>
				</div>
			</div>
			</Link>
		</div>
		)
}

export default prodListaMod;



// WEBPACK FOOTER //
// ./src/components/prodlistamod.js